export default "__VITE_ASSET__DWlwsDe4__"